import { PropTypes } from 'react';

export const ADDRESS_SHAPE = PropTypes.shape({
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  province: PropTypes.string,
  postalCode: PropTypes.string
});

export const CONFIG_SHAPE = PropTypes.shape({
  SERVLET_URL: PropTypes.string.isRequired,
  GOOGLE_MAPS_KEY: PropTypes.string,
  USER_PORTAL_URL: PropTypes.string,
  LOCALYTICS_APP_KEY: PropTypes.string
});

export const LOCATION_SHAPE = PropTypes.shape({
  address: ADDRESS_SHAPE,
  latLng: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  })
});

export const RECRUIT_SHAPE = PropTypes.shape({
  accountId: PropTypes.number,
  category: PropTypes.shape({
    accountDetail: PropTypes.object,
    accountId: PropTypes.number,
    color: PropTypes.string,
    created: PropTypes.number,
    id: PropTypes.string,
    name: PropTypes.string,
    priority: PropTypes.number,
    updated: PropTypes.number,
    version: PropTypes.number,
  }),
  clubJerseyNumber: PropTypes.string,
  clubTeam: PropTypes.string,
  created: PropTypes.number,
  firstName: PropTypes.string,
  hidden: PropTypes.bool,
  id: PropTypes.string,
  lastName: PropTypes.string,
  latestCurrentSchoolPeriod: PropTypes.object,
  nextEvent: PropTypes.object,
  numNotes: PropTypes.number,
  photo: PropTypes.object,
  position: PropTypes.object,
  recruitTourneys: PropTypes.array,
  schoolPeriods: PropTypes.array,
  updated: PropTypes.number,
  version: PropTypes.number,
  year: PropTypes.number
});

export const USER_EVENT_DATA_SHAPE = PropTypes.shape({
  accountDetails: PropTypes.object,
  accountId: PropTypes.number,
  attended: PropTypes.bool,
  created: PropTypes.number,
  event: PropTypes.object,
  flagged: PropTypes.bool,
  id: PropTypes.string,
  updated: PropTypes.number,
  userDetails: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.string,
    initials: PropTypes.string,
    lastName: PropTypes.string,
    name: PropTypes.string,
  }),
  userId: PropTypes.string
});

export const EVENT_SHAPE = PropTypes.shape({
  accountId: PropTypes.number,
  accountUserEventData: PropTypes.arrayOf(USER_EVENT_DATA_SHAPE),
  cancelled: PropTypes.bool,
  created: PropTypes.number,
  eventType: PropTypes.string,
  externalId: PropTypes.string,
  id: PropTypes.string,
  league: PropTypes.shape({
    created: PropTypes.number,
    gender: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    updated: PropTypes.number
  }),
  localDate: PropTypes.string,
  location: LOCATION_SHAPE,
  recruits: PropTypes.array,
  scheduled: PropTypes.number,
  schools: PropTypes.arrayOf(PropTypes.shape({
    school: PropTypes.shape({
      created: PropTypes.number,
      externalId: PropTypes.string,
      id: PropTypes.string,
      mainLocation: LOCATION_SHAPE,
      name: PropTypes.string,
      numGames: PropTypes.number,
      numRecruits: PropTypes.number,
      private: PropTypes.bool,
      source: PropTypes.string,
      updated: PropTypes.number,
    }),
    side: PropTypes.string
  })),
  source: PropTypes.string,
  updated: PropTypes.number
});

export const SIZES = PropTypes.oneOf([ 'xs', 'sm', 'md', 'lg', 'xl' ]);

export const SORT_INFO_SHAPE = PropTypes.shape({
  attribute: PropTypes.string.isRequired,
  desc: PropTypes.bool.isRequired
});

export const PAGE_INFO_SHAPE = PropTypes.shape({
  pageSize: PropTypes.number.isRequired,
  pageNo: PropTypes.number.isRequired
});

export const ID_REQUIRED = PropTypes.shape({ id: PropTypes.string.isRequired });

export default {
  ID_REQUIRED,

  CONFIG_SHAPE,

  EVENT_SHAPE,

  LOCATION_SHAPE,
  PAGE_INFO_SHAPE,
  RECRUIT_SHAPE,
  SORT_INFO_SHAPE,

  // commonly used size strings, based on bootstrap classes
  SIZES,
  USER_EVENT_DATA_SHAPE
};




// WEBPACK FOOTER //
// ./src/js/util/constants/propTypes.js